import { GetComponentQuery, GetPageByRouteQuery } from "@eurodrive/apollo"
import { BlockRenderer } from "@eurodrive/ui"
import { getBreadCrumbs, transformProperties } from "@eurodrive/utils"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  brands: GetComponentQuery
}

// Define the components mapping object based on the block types from the query
const components = {
  heroBannerInnerPages: () => import("@eurodrive/ui/Banner"),
  textAndImageOnTheSideWithCustomersStrip: () =>
    import("@eurodrive/ui/TextImageBlock"),
  reasonsWhy: () => import("@eurodrive/ui/ReasonsWhy"),
  lastSawVehicles: () => import("@eurodrive/ui/PreviouslyViewed"),
}

export default function About({ data, locale, brands }: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)

  let textImageBlockCount = 0

  return (
    <>
      {blocks?.blocks?.map((block: any, index: number) => {
        // Skip lastSawVehicles block if locale is not Hebrew
        if (block.blockType === "lastSawVehicles" && locale !== "he") {
          return null
        }

        let blockProps = {}
        if (block.blockType === "heroBannerInnerPages" && locale === "he") {
          blockProps = { breadCrumbs }
        }
        if (block.blockType === "lastSawVehicles") {
          blockProps = { brands }
        }
        if (block.blockType === "textAndImageOnTheSideWithCustomersStrip") {
          textImageBlockCount++
          blockProps = { blockIndex: locale === "he" ? textImageBlockCount : 0 }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            locale={locale}
            props={blockProps}
          />
        )
      })}
    </>
  )
}
